/**
 * This is the query to get the posts by category.
 */

import gql from 'graphql-tag';
import FRAGMENT_POST_OBJECT_MODEL from '@/graphql/wordpress/_fragments/fragmentPostObjectModel';

const QUERY_GET_POSTS_BY_CATEGORY = gql`
  ${FRAGMENT_POST_OBJECT_MODEL}

  query getPostsByCategory(
    $termId: String
    $count: Int
    $taxonomy: TaxonomyEnum = CATEGORY
  ) {
    posts(
      first: $count
      where: {
        taxQuery: {
          taxArray: [
            {
              terms: [$termId]
              field: ID
              includeChildren: true
              taxonomy: $taxonomy
            }
          ]
        }
      }
    ) {
      nodes {
        ...PostObjectModel
      }
    }
  }
`;

export default QUERY_GET_POSTS_BY_CATEGORY;
